export const preorderSubmit = function () {
    $('.add-to-cart-preorder').click(function (e) {
        e.preventDefault();
        const form = jQuery('form.cart');
        form.append('<input type="hidden" name="preorder" value="tak">');
        $('.single_add_to_cart_button').click();
    });


    $('.variations_form').on('show_variation', function () {

        const stockStatus = $('.stock-status').data('stock');
        const preorderArea = $('.preorder-area');
        const preorderButton = $('.add-to-cart-preorder ');


        if (stockStatus === 'outlet') {
            preorderArea.hide();
            preorderButton.attr('disable', true);
        } else {
            preorderArea.show();
            preorderArea.attr('disable', false);
        }

    });

};